/**
 * @desc 审核领用单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.LendMasterAuditActivitiDto, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/audit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
